export default __webpack_public_path__ + "static/media/17_JUSTIME.ed1a790e.png";